import ReactDOM, { Root } from 'react-dom/client';
import { createElement, ReactNode } from "react";
import style from "./Loading.module.css";

interface MountRoot {
    container: HTMLElement;
    root: Root;
}

let mountRoot: MountRoot | null = null;

function Loading(props: {
    center: boolean;
    message: string;
    zIndex?: number;
    borderWidth?: string;
    borderColor?: string;
    borderTopColor?: string;
    onClose?: () => void;
    children?: ReactNode;
}) {
    return (
        <div className={[style["loading-root"], props.center ? style["center"] : null].join(" ")} style={props.center ? { 'zIndex': props.zIndex || 999 } : undefined}>
            <i className={style["loading"]} style={{
                'borderWidth': props.borderWidth || '0.5em',
                'borderColor': props.borderColor || '#666',
                'borderTopColor': props.borderTopColor || '#fff'
            }}>
            </i>
            {props.children || props.message}
        </div >
    );
}

export function show(props?: {
    message: string;
    zIndex?: number;
    borderWidth?: string;
    borderColor?: string;
    borderTopColor?: string;
    onClose?: () => void;
}) {
    let newProps = Object.assign({}, props, {
        center: true
    });
    if (!mountRoot) {
        const container = document.createElement("div");
        document.body.appendChild(container);
        const root = ReactDOM.createRoot(
            container as HTMLElement
        );
        mountRoot = {
            container: container,
            root: root
        };
        root.render(createElement(Loading, newProps));
    }
}

export function hide() {
    if (mountRoot) {
        mountRoot.root.unmount();
        document.body.removeChild(mountRoot.container);
        mountRoot = null;
    }
}

export default Loading;